import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const included = ['6 complete teaching volumes', '5 strategic bonuses', '300+ ready-to-teach sessions', '120+ visual reference cards', 'Beginner through advanced', 'Lifetime access to all materials'];
export function Offer() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-6 bg-paper-200 py-14 sm:py-20" data-id="element-152" data-mp="tyv51a784bx7">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-153" data-mp="p0jwr3wku9h3">
        <div className="border-t-4 border-gold bg-paper" data-id="element-154" data-mp="p24pqp38tkcu">
          <div className="bg-wood-dark px-5 py-8 text-center sm:px-10 sm:py-10" data-id="element-155" data-mp="13xsqg49crpbz">
            <h2 id="offer-heading" className="font-display text-2xl font-semibold uppercase leading-tight text-paper sm:text-4xl" data-id="element-156" data-mp="yxoij2mig2xd">
              Jazz Teacher&rsquo;s Arsenal&trade; &mdash; Complete Package
            </h2>
            <p className="mt-3 text-sm font-semibold text-gold sm:text-base" data-id="element-157" data-mp="2affxukoe3762">
              6 Volumes + 5 Strategic Bonuses
            </p>
          </div>

          <div className="px-5 py-8 sm:px-10 sm:py-10" data-id="element-158" data-mp="ui0i83nrqv4g">
            <img src="https://cdn.magicpatterns.com/uploads/vFchDyybp1gA7zUWkdrNdP/ChatGPT_Image_25_ago_2026,_12_38_39_p.m..png" alt="Everything included in the Jazz Teacher's Arsenal package" className="mx-auto w-full max-w-xl" data-id="element-159" data-mp="ziob6uvk5m1b" />

            <div className="mt-8 border-t border-paper-300 pt-8" data-id="element-160" data-mp="bstxkb3eztg0">
              <p className="text-center text-[11px] font-semibold uppercase tracking-label text-ink-muted" data-id="element-161" data-mp="btc5w63cpy4a">
                What&rsquo;s included
              </p>
              <ul className="mt-6 grid gap-4 sm:grid-cols-2 sm:gap-x-8" data-id="element-162" data-mp="kldzbkf06e52">
                {included.map(item => <li key={item} className="flex items-start gap-3" data-id="element-163" data-mp="3k7ufic8xxlq0">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brass-wash" aria-hidden="true" data-id="element-164" data-mp="3o9pevb7b9p15">
                      <CheckIcon className="h-3.5 w-3.5 text-brass-dark" data-id="element-165" data-mp="qhfnlsgmv4ai" />
                    </span>
                    <span className="text-sm font-semibold leading-snug text-ink sm:text-base" data-id="element-166" data-mp="155tpa02bcmph">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 border-t border-paper-300 pt-8 text-center" data-id="element-167" data-mp="chel68kpzosx">
              <p className="text-[11px] font-semibold uppercase tracking-label text-ink-muted" data-id="element-168" data-mp="7itjs5tqez2w">
                Total real value: <span className="line-through" data-id="element-169" data-mp="lj4ddgmferrr">$707</span>
              </p>
              <p className="mt-4 flex items-baseline justify-center gap-3" data-id="element-170" data-mp="hfpu8h36xva3">
                <span className="font-display text-6xl font-semibold leading-none text-ink sm:text-7xl" data-id="element-171" data-mp="1wwgal8nokc4y">
                  $25
                </span>
                <span className="font-display text-xl leading-none text-ink-muted line-through" data-id="element-172" data-mp="1sul840u0jspl">
                  $707
                </span>
              </p>
              <p className="mt-4 inline-block bg-brass-wash px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.08em] text-brass-dark" data-id="element-173" data-mp="25e9wsr6d38z9">
                You save $682 &mdash; 96% discount
              </p>
              <p className="mt-3 text-[11px] uppercase tracking-label text-ink-muted" data-id="element-174" data-mp="1veresga0hx9u">
                One-time payment &middot; Lifetime access
              </p>

              <div className="mt-7" data-id="element-175" data-mp="2o48dfvo86aei">
                <CtaButton size="lg" fullWidth data-id="element-176" data-mp="2o36piqm41tfd">
                  Yes, I want the Arsenal
                </CtaButton>
              </div>

              <p className="mt-5 text-xs text-ink-muted" data-id="element-177" data-mp="29f277nqyzjx4">
                Covered by our 7-day money-back guarantee.
              </p>
              <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 border-t border-paper-300 pt-4" data-id="element-178" data-mp="3249cd5kxj7rc">
                <span className="flex items-center gap-2 text-[11px] text-ink-muted" data-id="element-179" data-mp="36uzjan907io5">
                  <LockIcon className="h-3.5 w-3.5 text-brass" aria-hidden="true" data-id="element-180" data-mp="1j64masqxkdpf" />
                  Secure payment
                </span>
                <span className="flex items-center gap-2 text-[11px] text-ink-muted" data-id="element-181" data-mp="1e6i8ah3a2tfk">
                  <ZapIcon className="h-3.5 w-3.5 text-brass" aria-hidden="true" data-id="element-182" data-mp="1999qihm1kreu" />
                  Instant access
                </span>
                <span className="flex items-center gap-2 text-[11px] text-ink-muted" data-id="element-183" data-mp="14b8bq8vnfe96">
                  <CreditCardIcon className="h-3.5 w-3.5 text-brass" aria-hidden="true" data-id="element-184" data-mp="21w4896rh5com" />
                  Card &middot; Google Pay &middot; Apple Pay
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}